import type { orpcClient } from "@/frontend/orpc-client";
import {
  WEBHOOK_EVENT_TYPES,
  type WebhookEventType,
} from "@/server/types/webhook";
import { WEBHOOK_ENDPOINT_LIMIT_PER_ORG } from "@/server/api/constants";
import type { SettingsSearch } from "./index";

/** Endpoint row shape as the dashboard receives it from `listWebhooks` —
 *  derived from the RPC return so it tracks the schema. */
export type WebhookEndpoint = Awaited<
  ReturnType<typeof orpcClient.webhooks.listWebhooks>
>[number];

/** Short alias matching the section-flavored naming in this folder. */
export type EventType = WebhookEventType;

export { WEBHOOK_EVENT_TYPES };

/** Per-event display labels for the create-webhook dialog and the detail view. */
export const EVENT_LABELS: Record<EventType, string> = {
  "patient_session.completed": "Patient session completed",
  "connection.token_refresh_failed": "Connection token refresh failed",
  "records.sync.completed": "Records sync completed",
  "records.sync.failed": "Records sync failed",
};

/** Delivery-log status filter tabs (mirrors `activity.ts`). */
export const STATUS_TABS = [
  { key: "all", label: "All" },
  { key: "delivered", label: "Delivered" },
  { key: "pending", label: "Pending" },
] as const;

/** Per-org webhook endpoint cap. Re-exported so dashboard code doesn't
 *  reach into `@/server/api/constants` directly. */
export const MAX_ENDPOINTS = WEBHOOK_ENDPOINT_LIMIT_PER_ORG;

/** Search-params literal for navigating back to the webhook list. */
export const SEARCH_TO_LIST: SettingsSearch = {
  section: "webhooks",
  webhookId: undefined,
  destinationId: undefined,
  provider: "",
};
